export default __webpack_public_path__ + "static/media/adelsten.7f088b47.jpg";